import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import CryptoJS from 'crypto-js';
import {
  Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';

export default {
  name: "permissions",
  components: {
    Paginate,
    VueElementLoading
  },
  data: function() {
    return {
      updaterolemodal: false,
      editrolemodal: false,
      addpermissionmodal: false,
      permissionaction: "",
      listPermissionsData: [],
      listPermissionData: [],
      permissionid: [],
      pageno: 0,
      pagecount: 0,
      permissionname: "",
      perm_id: [],
      roleid: [],
      parentid: "",
      devicetype: '',
      isLoading: false,
      resultCount: '',
      model: {
        name: "",
        username: ""
      },
      addpermission: {
        permissionname: "",
        perm_name: "",
        controller_url: "",
        purl: "",
        is_active:"",
        ismenu:""
      },
      checkedPerm_Id: [],
      projectid: [],
      listProjectData: [],
      listParentIdsData: [],
      listRolesData: [],
      selected: ''
    };
  },

  created: function() {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusername = userdetail.username;
    this.getPermisionData();
    this.getParentIdsData();
    this.getRolesListData();
  },
  methods: {
    addNewpermission() {
      this.addpermission.permissionid = '';
      this.addpermission.perm_name= "";
      this.addpermission.controller_url= "";
      this.addpermission.purl= "";
      this.addpermission.is_active=true;
      this.addpermission.ismenu="";
      this.addpermission.sequence="";
      this.addpermission.permissionname="";
      this.roleid= [];
      this.parentid= 0;
      this.devicetype= "";
      this.checkedPerm_Id = [];
      this.permissionaction = "add";
      this.addpermissionmodal = true;
      this.$validator.reset();
      this.errors.clear();
    },
    closeAddPermissionModal() {
      $("#permissionform").trigger("reset");
      this.projectid=[];
      this.devicetype= "";
      this.is_active ="";
      this.ismenu="";
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.addpermissionmodal = false;
      this.$validator.reset();
      this.errors.clear();
      this.resetform();
    },
    closeEditRoleModal() {
      this.addpermissionmodal = false;
      this.$validator.reset();
      this.errors.clear();
    },
    resetSearch() {
      this.permissionname = '';
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getPermisionData();
    },
    resetform() {
      this.addpermission.permissionid = '';
      this.projectid=[];
      this.devicetype= "";
      this.is_active= "";
      this.ismenu="";
      this.checkedPerm_Id = [];
      this.listPermissionData= [];
      this.permissionid= [];
      this.getPermisionData();
    },
    searchPermisionData(){
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getPermisionData();
    },
    getPermisionData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = {
        offset: this.pageno,
        limit: 10,
        permissionname: this.permissionname
      };
      this.isLoading = true;
      axios({
        method: "POST",
        url: apiUrl.api_url + "permissionsMaster",
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(
        result => {
          this.listPermissionsData = result.data.rows;
          this.isLoading = false;
          let totalRows = result.data.count;
          this.resultCount = result.data.count
          if (totalRows < 10) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(totalRows / 10);
          }
        },
        error => {
          console.error(error);
        }
      );
    },

    savePermission(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      axios({
          method: "POST",
          url: apiUrl.api_url + "SubmitPermissionData",
          data: {
            permissionname: this.addpermission.permissionname,
            parentid: this.parentid,
            controller_url: this.addpermission.controller_url,
            purl: this.addpermission.purl,
            sequence: this.addpermission.sequence,
            is_active: this.addpermission.is_active,
            roleids: this.roleid,
            ismenu: (this.addpermission.ismenu)?this.addpermission.ismenu:false,
            createdby:this.localusername

          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
            if (response.status == 200) {
            this.addpermissionmodal = false;
            this.$alertify.success("Permission Created Successfully");
            event.target.reset();
            this.resetform();
          } else if (response.data.status == 209) {
            this.$alertify.error("Permission Already Exist");
            this.addpermissionmodal = false;
          } else if (response.data.status == 400) {
            this.$alertify.error("Failed");
            this.addpermissionmodal = false;
          }
        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    getPermissionRowData(data) {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      this.$validator.reset();
      this.errors.clear();
      this.permissionaction = "edit";
      this.addpermissionmodal = true;
      this.checkedPerm_Id = [];
      this.roleid = [];
      let tempthis = this;

      axios({
        method: "POST",
        url: apiUrl.api_url + "getPermissionsRoleData",
        data: {
          permissionid: data.permissionid
        },
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      }).then(
        result => {
          result.data.forEach(function(value) {
            //by using tempthis variable we provided the current access to the checkedPerm_Id array which not accessible from out of the function which is getRoleRowData
            //tempthis.checkedPerm_Id.push(value.permissionid);
            tempthis.roleid.push(value.roleid);
          });
        },
        error => {
          console.error(error);
        }
      );
      this.addpermission = data;
      this.addpermission.controller_url = data.controllerurl;
      this.addpermission.sequence = data.permsequence;
      this.parentid = data.parentid;
      this.addpermission.ismenu=data.ismenu;
      this.addpermission.is_active = data.is_active;

    },

    editPermission(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      //var roleid = this.checkedPerm_Id.map(Number);
      axios({
          method: "POST",
          url: apiUrl.api_url + "UpdatePermission",
          data: {
            permissionname: this.addpermission.permissionname,
            permissionid: this.addpermission.permissionid,
            controllerurl: this.addpermission.controller_url,
            purl: this.addpermission.purl,
            permsequence: this.addpermission.sequence,
            parentid: this.parentid,
            is_active:this.addpermission.is_active,
            roleids: this.roleid,
            ismenu: (this.addpermission.ismenu)?this.addpermission.ismenu:false,
            modifiedby:this.localusername
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(response => {
          if (response.status == 200) {
            this.$alertify.success("Permission updated successfully");
            this.addpermissionmodal = false;
            event.target.reset();
            this.resetform();
          } else {
            this.$alertify.error("Permission failed to update");
            this.addpermissionmodal = false;
          }
        })
        .catch(httpException => {
          console.error("exception is:::::::::", httpException);
        });
    },

    //to get project list
    getParentIdsData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getParentIds',
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listParentIdsData = result.data.data.rows;
        }, error => {
          console.error(error)
        })
    },

    getRolesListData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getAllRolesListData',
          data: {
            roletype: '1',
          },
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listRolesData = result.data.data;
        }, error => {
          console.error(error)
        })
    },

    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.getPermisionData();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          //console.log('form is valid', this.model);
          if(this.addpermission.permissionid!=undefined && this.addpermission.permissionid!=""){
            this.editPermission(event);
          }else{
            this.savePermission(event);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/permissions/permissions.component.js